import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/img.png'
import _imports_1 from './_images/img_1.png'
import _imports_2 from './_images/img_2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-47287fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = { class: "item-wrapper" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "normal-desc" }
const _hoisted_6 = { class: "item-wrapper" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "normal-desc" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "item-wrapper" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "normal-desc" }
const _hoisted_13 = { class: "item-wrapper" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "normal-desc" }
const _hoisted_16 = { class: "normal-desc cm-ui-mt10" }
const _hoisted_17 = { class: "item-wrapper" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "normal-desc" }
const _hoisted_20 = { class: "normal-desc" }
const _hoisted_21 = { class: "normal-desc" }
const _hoisted_22 = { class: "normal-desc" }
const _hoisted_23 = ["alt"]
const _hoisted_24 = { class: "item-wrapper" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "normal-desc" }
const _hoisted_27 = ["alt"]
const _hoisted_28 = { class: "cm-ui-mt10" }
const _hoisted_29 = { class: "normal-desc cm-ui-mt10" }
const _hoisted_30 = { class: "item-wrapper" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "normal-desc" }
const _hoisted_33 = { class: "item-wrapper" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "normal-desc" }
const _hoisted_36 = { class: "item-wrapper" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "normal-desc" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { useI18n } from 'vue-i18n'
import { useHelpBody } from '@/views/help/use-help-body'


export default /*#__PURE__*/_defineComponent({
  __name: 'subscribe-help',
  setup(__props) {

const { t } = useI18n()
useHelpBody()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('subscribeHelp.pageTitle')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('subscribeHelp.q1Title')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q1P1')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q1P2')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q1P3')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q1P4')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('subscribeHelp.q2Title')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q2Body')), 1),
        _createElementVNode("img", {
          class: "cm-ui-mt10",
          src: _imports_0,
          alt: _unref(t)('subscribeHelp.imgAlt1')
        }, null, 8, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('subscribeHelp.q3Title')), 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P1')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P2')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P3')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P4')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P5')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P6')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('subscribeHelp.q3P7')), 1),
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('subscribeHelp.q3P7Strong')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q3P8')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('subscribeHelp.q4Title')), 1),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q4ForExample')), 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q4E1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q4E2')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q4E3')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q4E4')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('subscribeHelp.q5Title')), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('subscribeHelp.q5Intro')), 1),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q5W1')), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q5W2')), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q5W3')), 1),
        _createElementVNode("img", {
          class: "cm-ui-mt10",
          src: _imports_1,
          alt: _unref(t)('subscribeHelp.imgAlt2')
        }, null, 8, _hoisted_23)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('subscribeHelp.q6Title')), 1),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('subscribeHelp.q6D1')), 1),
        _createElementVNode("img", {
          class: "cm-ui-mt10",
          src: _imports_2,
          alt: _unref(t)('subscribeHelp.imgAlt3')
        }, null, 8, _hoisted_27),
        _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('subscribeHelp.q6Example')), 1),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q6E1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('subscribeHelp.q6E2')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('subscribeHelp.q7Title')), 1),
      _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('subscribeHelp.q7Body')), 1)
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('subscribeHelp.q8Title')), 1),
      _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('subscribeHelp.q8Body')), 1)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('subscribeHelp.q9Title')), 1),
      _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('subscribeHelp.q9Body')), 1)
    ]),
    _hoisted_39,
    _hoisted_40
  ]))
}
}

})